import { VariantProps, cva } from 'class-variance-authority';

/**
 * 48
 * 80 - krótkie wartości liczbowe, np. nr budynku
 * 100 - np. unit selector
 * 120 - np. pln
 * 156 - jeden dzień pole daty
 * 180 - short text
 * 200 - krótkie hasła, np. wybór jednostki
 * 224 - lista wybierana w modalu
 * 320 - default, np. nazwy własne, ale być zakres dat (najczęstszy)
 * 400
 * 560 - opisy, dłuższe wartości, np. notatka
 * 720
 */
export const maxWidthVariants = cva('w-full', {
  variants: {
    maxWidth: {
      full: 'max-w-full',
      48: 'max-w-12',
      80: 'max-w-20',
      100: 'max-w-25',
      120: 'max-w-30',
      156: 'max-w-40',
      180: 'max-w-45',
      224: 'max-w-56',
      320: 'max-w-80',
      400: 'max-w-100',
      560: 'max-w-140',
      720: 'max-w-180',
    },
  },
  defaultVariants: {
    maxWidth: 'full',
  },
});

export type MaxWidthProp = VariantProps<typeof maxWidthVariants>['maxWidth'];
